import TokenService from "@/helpers/token";
import Repository from "./Repository";

const baseUrl = `${Repository.defaults.baseURL}/exams`;
const linkExamURL = Repository.defaults.linkExamURL;

export default {
  // Danh sách "Phân loại kỳ thi"
  async listType(params) {
    const response = await Repository.get(`${baseUrl}/types`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },

  // Danh sách "Kỳ thi"
  async listExam(params) {
    const response = await Repository.get(`${baseUrl}`, {
      headers: TokenService.getHeader(),
      params,
    });
    return response;
  },

  // get link detail DGNL
  async getLinkDetailDGNL(examBatchId,userId) {
    const response = await Repository.get(`${linkExamURL}/internal/v1/exam-batches/${examBatchId}/users/${userId}/exam-batch-answers/link`, {
      headers: {
        'Authorization': 'Bearer ' + process.env.VUE_APP_TOKEN_EXAM,
      },
    });
    console.log(response,'response');
    return response;
  },
};
